import { axios } from '@/utils/axios'
// import _ from 'lodash'
// import moment from 'moment'
// import Storage from '@/assets/js/storage'

// 校验实名认证本人
export async function verifyOneself (params) {
  try {
    return await axios.post('/api/order/coupon/cert/check', params)
  } catch (error) {
    return Promise.reject(error)
  }
}
